import React from "react";
import { useInjectReducer } from "@app/store";
import { useDispatch, useSelector } from "react-redux";
import { makeSelectAccess } from "@features/auth/authSlice";
import homepageSlice from "@features/publicPage/homepage/slice";
import { useLoadAllHomepageLayoutsQuery } from "@features/publicPage/homepage/api";
import HomePageContentSection from "./components/sections/ContentSection";
import HomePageSliderSection from "./components/sections/SliderSection";
import HomePageOfferSection from "./components/sections/OfferSection";
import { Fragment } from "react";

const HomePage = () => {
  useInjectReducer("homepage", homepageSlice);
  const dispatch = useDispatch();
  const access = useSelector(makeSelectAccess);

  // load homepage layouts;
  const { data: homeLayoutData } = useLoadAllHomepageLayoutsQuery("", {
    refetchOnMountOrArgChange: true,
  });

  const sectionsArray = homeLayoutData?.data?.section?.data || [];

  const returnAccToSection = (each) => {
    switch (each.layout_type) {
      case "content":
        return <HomePageContentSection section_data={each} />;
      case "slider":
        return <HomePageSliderSection section_data={each} />;
      case "product":
        return <HomePageOfferSection section_data={each} />;
    }
  };

  return (
    <>
      {sectionsArray.map((each) => (
        <Fragment key={each._id}>{returnAccToSection(each)}</Fragment>
      ))}
    </>
  );
};

export default HomePage;
